import React, { useEffect, useContext, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import axios from 'axios';

import AppContext from 'AppContext';
import { getArrayByKey } from 'utils/misc';

import Button from 'components/CustomButtons/Button';
import NotificationBar from 'modules/NotificationBar';
import useSsoConnection from 'hooks/useSsoConnection';

export default function OrgInvitePage() {
  const history = useHistory();
  const { orgId, inviteId } = useParams();
  const { isAuthenticated, userMeta } = useContext(AppContext);
  const [orgName, setOrgName] = useState();
  const { loginUrl } = useSsoConnection({ orgId, isDeepLink: true });

  const [isValid, setIsValid] = useState();
  const [error, setError] = useState();
  const [hint, setHint] = useState();
  const orgs = getArrayByKey(userMeta?.orgs, 'id');

  const onJoin = () => {
    axios
      .post(`/api/org/${orgId}/join`, {
        inviteId
      })
      .then(() => {
        // Important: update or joined team won't show, userMeta is not updated seems ok
        //switchOrg({orgId});
        //history.replace('/dashboard');

        window.location.pathname = '/';
      })
      .catch((e) => {
        if (e?.response?.status === 405) {
          setHint('You organization has SSO enabled. Please sign out and sign in with SSO.');
        }
        setError(true);
        Sentry.captureException(e);
      });
  };

  const renderNotValid = () => {
    return (
      <div className="welcomeModal">
        <h2>
          Oops{' '}
          <span role="img" aria-label="">
            😔
          </span>
        </h2>
        <p>This invite link is no longer valid, please contact your organization to get a new invite link. </p>
      </div>
    );
  };

  const renderInviteView = () => {
    return (
      <div className="welcomeModal">
        <h2>
          You’re invited!{' '}
          <span role="img" aria-label="">
            🎉
          </span>
        </h2>
        <p>
          Congratulations!{' '}
          {orgName ? (
            <>
              You’ve been invited to join: <strong>{orgName}</strong>
            </>
          ) : (
            'You’ve been invited to join your organization.'
          )}
        </p>
        {isAuthenticated ? (
          <div>
            {/* <p>
              Click the <strong>Join</strong> button below to be part of the organization.
            </p> */}
            {hint ? (
              <p>
                <b>{hint}</b>
              </p>
            ) : null}
            <Button onClick={onJoin}>Join organization</Button>
          </div>
        ) : (
          <div>
            <p>Please sign in to accept this invitation.</p>
            <Button href={loginUrl}>Sign in</Button>
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    axios
      .get(`/api/org/${orgId}/invitation`, {
        params: {
          inviteId
        }
      })
      .then(({ data }) => {
        const { name } = data;
        setOrgName(name);
        setIsValid(true);
      })
      .catch((e) => {
        setIsValid(false);
        Sentry.captureException(e);
        return e;
      });
  }, [orgId, inviteId, setIsValid]);

  useEffect(() => {
    if (orgs.includes(orgId)) {
      history.replace('/');
    }
  }, [orgId, orgs, history]);

  return (
    <div className="staticPage-container">
      <div className="staticPage-content">
        {isValid === false && renderNotValid()}
        {isValid && renderInviteView()}
      </div>
      {error && <NotificationBar message="Sorry something went wrong." type="error" closeCallback={() => setError()} />}
    </div>
  );
}
